/**
 * Tracking de views/cliques de anúncios e banners (rota /wp-json/api/v1/relatorios/).
 *
 * Antes: cada card da listagem e cada banner disparava o próprio POST de view ao
 * carregar (≈22 requisições por listagem) e cada uma subia o WordPress inteiro.
 * Agora: as views da página são acumuladas e enviadas em UMA requisição para
 * /relatorios/lote; cliques continuam unitários (são raros).
 *
 * A contagem é a mesma de antes: uma view por elemento rastreado a cada carregamento.
 * Só muda o número de requisições.
 *
 * Uso:
 *   - Banners: <a data-mg-track="123">…</a>  → view no carregamento + click no clique.
 *     Com data-mg-click-all, o clique em qualquer .banner-click registra em todos os rastreados.
 *   - Código carregado antes deste arquivo: (window.mgTrackQueue = window.mgTrackQueue || [])
 *       .push(['view', 123]) / .push(['event', 123, 'click']) / .push(['bind', '.sel', 123, 'whatsapp'])
 *   - Depois de carregado: window.medguiasTrack.view(id), .event(id, tipo), .bind(selector, id, tipo)
 *
 * Config (wp_localize_script → window.medguiasTracking): { relatoriosBase }
 */
(function () {
    'use strict';

    var cfg = window.medguiasTracking || {};
    var base = cfg.relatoriosBase || '/wp-json/api/v1/relatorios/';
    var FLUSH_DELAY = 400; // ms — junta as views do carregamento e do "carregar mais"
    var MAX_IDS = 60;      // espelha o limite do endpoint /lote

    var pending = []; // ids de views aguardando envio
    var timer = null;

    function post(url, payload, useBeacon) {
        var body = JSON.stringify(payload);
        if (useBeacon && navigator.sendBeacon) {
            try {
                // Blob com application/json: same-origin, sem preflight.
                if (navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }))) return;
            } catch (e) { /* cai no fetch */ }
        }
        try {
            fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: body,
                keepalive: true,
                credentials: 'same-origin'
            }).catch(function () {});
        } catch (e) { /* fetch indisponível */ }
    }

    function flush(useBeacon) {
        if (timer) { clearTimeout(timer); timer = null; }
        if (!pending.length) return;

        var ids = pending;
        pending = [];

        for (var i = 0; i < ids.length; i += MAX_IDS) {
            post(base + 'lote', { tipo: 'view', ids: ids.slice(i, i + MAX_IDS) }, useBeacon);
        }
    }

    function view(id) {
        id = parseInt(id, 10);
        if (!id) return;
        pending.push(id);
        if (!timer) timer = setTimeout(function () { flush(false); }, FLUSH_DELAY);
    }

    function event(id, tipo) {
        id = parseInt(id, 10);
        if (!id) return;
        tipo = tipo === 'whatsapp' ? 'whatsapp' : 'click';
        post(base + id, { tipo: tipo }, true);
    }

    // Liga um clique em todos os elementos do seletor (uso do perfil do médico).
    function bind(selector, id, tipo) {
        if (!selector) return;
        document.addEventListener('click', function (e) {
            if (e.target.closest && e.target.closest(selector)) event(id, tipo);
        });
    }

    // Banners: <a data-mg-track="ID"> → view ao carregar, click delegado.
    function scanBanners(root) {
        (root || document).querySelectorAll('[data-mg-track]').forEach(function (el) {
            if (el.getAttribute('data-mg-track-init') === '1') return;
            el.setAttribute('data-mg-track-init', '1');
            view(el.getAttribute('data-mg-track'));
        });
    }

    document.addEventListener('click', function (e) {
        if (!e.target.closest) return;

        // Banners com data-mg-click-all (listagens, busca, taxonomias): o clique em
        // qualquer .banner-click da página registra em todos os banners rastreados,
        // como o script inline original dessas páginas fazia.
        var all = document.querySelectorAll('[data-mg-track][data-mg-click-all]');
        if (all.length && e.target.closest('.banner-click')) {
            all.forEach(function (el) { event(el.getAttribute('data-mg-track'), 'click'); });
            return;
        }

        var el = e.target.closest('[data-mg-track]');
        if (el) event(el.getAttribute('data-mg-track'), el.getAttribute('data-mg-track-tipo') || 'click');
    });

    // Envia o que ficou pendente se o usuário sair antes do timer.
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') flush(true);
    });
    window.addEventListener('pagehide', function () { flush(true); });

    var api = { view: view, event: event, bind: bind, scan: scanBanners, flush: flush };

    function drainQueue() {
        var q = window.mgTrackQueue;
        if (!q || !q.length) return;
        for (var i = 0; i < q.length; i++) {
            var item = q[i];
            if (item && api[item[0]]) api[item[0]].apply(null, item.slice(1));
        }
        q.length = 0;
    }

    // Chamadas feitas depois do carregamento vão direto para a API.
    window.mgTrackQueue = window.mgTrackQueue || [];
    window.mgTrackQueue.push = function (item) {
        if (item && api[item[0]]) api[item[0]].apply(null, item.slice(1));
        return 0;
    };
    window.medguiasTrack = api;

    function init() {
        drainQueue();
        scanBanners();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
